import React, { useEffect, useState } from 'react';
import { Typography, Box, IconButton, TextField } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const COMMENT_HEIGHT_COMPACT = '80px';
const COMMENT_HEIGHT_EXPANDED = 'min(40vh, 480px)';

function BookingCommentSection({
  comment,
  onCommentChange,
  hasMinorUpdateRights,
  saving,
  bookingId,
}) {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    setExpanded(false);
  }, [bookingId]);

  return (
    <>
      <Box sx={{ display: 'flex', alignItems: 'center', mt: 4 }}>
        <Typography variant='h6'>
          Kommentar
        </Typography>
        <IconButton size='small' onClick={() => setExpanded(e => !e)} sx={{ ml: 0.5 }}>
          {expanded ? <ExpandLessIcon fontSize='small' /> : <ExpandMoreIcon fontSize='small' />}
        </IconButton>
      </Box>
      <Box sx={{ mt: 2 }}>
        <TextField
          multiline
          fullWidth
          variant='outlined'
          data-testid='booking-details-comment'
          value={comment}
          onChange={e => onCommentChange(e.target.value)}
          disabled={!hasMinorUpdateRights}
          placeholder='Kommentar hinzufügen...'
          inputProps={{ 'aria-label': 'Kommentar' }}
          onFocus={() => setExpanded(true)}
          sx={{
            '& .MuiOutlinedInput-root': {
              alignItems: 'stretch',
              backgroundColor: 'background.paper',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: 'divider',
            },
            '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: 'primary.main',
            },
            '& textarea': {
              // Collapsed the field is only floored at COMMENT_HEIGHT_COMPACT and grows with its
              // content, so no comment text is cut off without a scrollbar to show for it.
              minHeight: expanded ? COMMENT_HEIGHT_EXPANDED : COMMENT_HEIGHT_COMPACT,
              maxHeight: expanded ? '1000px' : 'none',
              resize: expanded ? 'vertical' : 'none',
              padding: expanded ? '16.5px 14px' : '8px 14px',
              fontSize: '16px',
              lineHeight: 1.5,
              boxSizing: 'border-box',
              overflow: 'auto',
            },
          }}
        />
      </Box>

      {saving && (
        <Typography variant='body2' color='text.secondary' mt={1}>
          Speichern...
        </Typography>
      )}
    </>
  );
}

export default BookingCommentSection;
